import { render } from "./news.vue?vue&type=template&id=5dc1f815&scoped=true&ts=true"
import script from "./news.vue?vue&type=script&lang=ts"
export * from "./news.vue?vue&type=script&lang=ts"

import "./news.vue?vue&type=style&index=0&id=5dc1f815&scoped=true&lang=css"
import "./news.vue?vue&type=style&index=1&id=5dc1f815&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc1f815"]])

export default __exports__